import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { formatINR } from "../mock";
import { imgUrl } from "../lib/api";

const statusStyles = {
  "AVAILABLE": "bg-emerald-50 text-emerald-700",
  "ALMOST SOLD OUT": "bg-orange-50 text-orange-700",
  "SOLD OUT": "bg-red-50 text-red-600",
};
const barStyles = {
  "AVAILABLE": "bg-emerald-500",
  "ALMOST SOLD OUT": "bg-orange-500",
  "SOLD OUT": "bg-red-500",
};

export default function TourCard({ tour }) {
  return (
    <Link
      to={`/tour/${tour.slug}`}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-slate-200 card-hover"
    >
      <div className="relative h-52 overflow-hidden">
        <img
          src={imgUrl(tour.cover)}
          alt={tour.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        {tour.withFlights && (
          <span className="absolute top-3 left-3 text-[11px] font-semibold bg-white/90 text-slate-800 px-2.5 py-1 rounded-full">
            ✈ With Flights
          </span>
        )}
        <span className="absolute top-3 right-3 text-[11px] font-semibold bg-coral-600 text-white px-2.5 py-1 rounded-full">
          {tour.duration}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-4">
        <h3 className="font-display font-semibold text-slate-900 leading-snug line-clamp-2">
          {tour.title}
        </h3>
        <p className="mt-1.5 text-sm text-slate-500 line-clamp-2 flex-1">{tour.short}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="flex items-center gap-1 text-sm text-slate-500">
            <MapPin className="w-4 h-4 text-coral-600" /> {tour.location}
          </span>
          <span className="font-display font-bold text-slate-900">{formatINR(tour.price)}</span>
        </div>
        <div className="mt-3">
          <span className={`inline-block text-[11px] font-bold tracking-wide px-2 py-0.5 rounded ${statusStyles[tour.status]}`}>
            {tour.status}
          </span>
          <div className="mt-2 h-1.5 rounded-full bg-slate-100 overflow-hidden">
            <div className={`h-full rounded-full ${barStyles[tour.status]}`} style={{ width: `${tour.fill}%` }} />
          </div>
        </div>
      </div>
    </Link>
  );
}
